import axiosInstance from "./config";

// ✅ CREATE EMPLOYEE
export const createEmployee = async (data) => {
  const response = await axiosInstance.post("/admin/create-employee", data);
  return response.data;
};

// ✅ GET ALL EMPLOYEES
export const getAllEmployees = async () => {
  const response = await axiosInstance.get("/admin/employees");
  return response.data;
};

// ✅ TOGGLE ACTIVE / INACTIVE
export const toggleEmployeeStatusApi = async (id) => {
  const res = await axiosInstance.put(`/admin/toggle-status/${id}`);
  return res.data;
};



// 🔥 NEW APIs START HERE



// ✅ UPDATE EMPLOYEE
export const updateEmployeeApi = async (id, data) => {
  const res = await axiosInstance.put(`/admin/update-employee/${id}`, data);
  return res.data;
};



// ✅ SEND RESET OTP
export const sendResetOtpApi = async (data) => {
  const res = await axiosInstance.post(`/auth/send-otp`, data);
  return res.data;
};



// ✅ RESET PASSWORD USING OTP
export const resetPasswordOtpApi = async (data) => {
  const res = await axiosInstance.post(`/auth/verify-otp`, data);
  return res.data;
};

// ✅ SEND REMINDER (ABSENT / PENDING CHECKOUT)
export const sendReminderApi = async (data) => {
  const res = await axiosInstance.post("/admin/send-reminder", data);
  return res.data;
};